// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_buttons.scss
// module id = 32
// module chunks = 0